import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { SelectorModel } from '../../../model/shared/selector.model';
import { SelectorModelV2 } from '../../../model/jubili/selector-model';
import { CompanyManageService } from '../../../service/api/jubili/company-manage.service';

@Component({
  selector: 'jubili-form-selector',
  templateUrl: './jubili-form-selector.component.html',
  styleUrls: ['./jubili-form-selector.component.scss']
})
export class JubiliFormSelectorComponent implements OnInit {

  constructor(
    private companyManageService: CompanyManageService
  ) { }

  formList: Array<SelectorModelV2>;
  @Input('defaultFormId') defaultFormId: number;
  @Input('language') language: number;
  @Input('formType') formType: number;
  @Input('formTypeName') formTypeName: string;
  @Output('selectedFormId') output = new EventEmitter<number>();

  ngOnInit() {
    // this.defaultFormId = 1
    // console.log(this.defaultFormId)
    this.getFormSelector();
  }

  selectForm(event: SelectorModelV2) {
    // console.log(event.id)
    this.output.emit(event.id);
  }
  getFormSelector() {
    this.companyManageService.getFormSelector(this.formType, this.language).subscribe(res => {
      this.formList = res;
    });
  }

}
